import DatricRequests from '../datric.requests';
import { ConsultaResult, HistoryItem } from '../../../models/consulta.model';

const requests = new DatricRequests();

export async function consultarCpf(cpf: string): Promise<ConsultaResult> {
	const clean = cpf.replace(/\D/g, '');
	return requests.get(`consulta/${clean}`);
}

export async function consultaHistory(): Promise<HistoryItem[]> {
	return requests.get('consulta/history');
}

// Revisualização gratuita de um lead do histórico (lê do cache no servidor).
export async function consultaHistoryDetail(cpf: string): Promise<ConsultaResult> {
	const clean = cpf.replace(/\D/g, '');
	return requests.get(`consulta/history/${clean}`);
}
